import SectionHeading from "./SectionHeading";
import { howToSteps } from "@/mocks/home";

export default function HowToFind() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="07"
          eyebrow="使用方式"
          title="三步找到今晚的片"
          desc="把它当成一个深夜找片小工具就好，不用注册、不用登录，勾选、看摘要、进入口。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {howToSteps.map((step) => (
            <div
              key={step.id}
              className="relative rounded-lg border border-background-300/50 bg-background-100 p-6"
            >
              <span className="font-label text-4xl leading-none text-primary-500/40">{step.step}</span>
              <h3 className="mt-3 font-display text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{step.desc}</p>
              <div className="absolute right-5 top-6 flex h-9 w-9 items-center justify-center rounded-full border border-background-300/50 text-primary-300">
                <i className="ri-guide-line text-base" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}